"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerController = void 0;
var csod = require("player-core");
var SpinnerController = (function () {
    function SpinnerController() {
    }
    SpinnerController.on = function (forceRender) {
        if (forceRender === void 0) { forceRender = false; }
        csod.viewModel.isLoading = true;
        forceRender && csod.engine.commit();
    };
    SpinnerController.off = function (forceRender) {
        if (forceRender === void 0) { forceRender = false; }
        csod.viewModel.isLoading = false;
        forceRender && csod.engine.commit();
    };
    return SpinnerController;
}());
exports.SpinnerController = SpinnerController;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/shared/code/SpinnerController.ts
// module id = 163
// module chunks = 0 2